//
//
//

import React, { useEffect, useState } from "react";

import { Row, Col, Form, Button, Table, InputGroup } from "react-bootstrap";

import ProvinceControl from "../../../components/molecules/ProvinceControl";
import FrequencyControl from "../../../components/molecules/FrequencyControl";


const input_text_style = {
  textAlign: "right",
  boxSizing: "border-box",
  width: "100%"
}

const input_text2_style = {
  textAlign: "right",
}

const expense_labels = {
  textAlign: "right",

}

const list_style = {
  margin: "10px"
}

//-------------------------------------------------------------------------------------------------
// TODO this will be a service or manager thats passed in

function getBudget() {
  let budget = [];

  function addItem(desc, amount) {
    let obj = {
      desc,
      amount
    };

    budget.push(obj);
  }

  addItem("Rent/Mortgage", "1100");
  addItem("Electricity", "100");
  addItem("Water", "50");
  addItem("Heat", "0");

  addItem("Groceries", "600");
  addItem("Restaurants/Take out", "120");

  addItem("Phone", "0");
  addItem("Internet/Cable", "75");
  addItem("Streaming services", "45");

  addItem("Entertainment", "100");

  addItem("Car payment", "300");
  addItem("Gas/Diesel", "150");
  addItem("Bus/Taxi/Uber", "0");

  addItem("Loan payments", "0");

  addItem("Other expense 1", "0");
  addItem("Other expense 2", "0");

  return budget;
}


function calcBudget(budget) {
  let total = 0;
  for (let i = 0; i < budget.length; i++) {
    let item = budget[i];

    let amt = item.amount.length > 0 ? parseFloat(item.amount) : 0;
    total += amt;
  }

  return total;
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------

function CanadaPayRequired(props) {
  const [budget, setBudget] = useState(getBudget());
  const [province, setProvince] = useState("NS");
  const [otherExpenses, setOtherExpenses] = useState("0");
  const [totalBudget, setTotalBudget] = useState(calcTotalExpenses());
  const [data, setData] = useState(null);


  useEffect(() => {
    updateTotalBudget();
  }, [budget, otherExpenses]);


  function updateBudget(newBudget) {
    setBudget(newBudget);
  }


  function updateOtherExpenses(event) {
    event.preventDefault();

    setOtherExpenses(event.target.value);
  }


  function updateTotalBudget() {
    let total = calcTotalExpenses();

    setTotalBudget(total);
  }


  // returned as a string  because the controls represent the value as a string
  function calcTotalExpenses() {
    let estimate = calcBudget(budget);
    let other = otherExpenses.length > 0 ? parseFloat(otherExpenses) : 0;

    let total = estimate + other;

    return total.toFixed(2);
  }


  function handleClick(event) {
    event.preventDefault();

    let body = {
      "province": province,
      "expenses": parseFloat(totalBudget)
    };


    let results = props.submitRequest('calculators/canadapayrequired', body).then(
      function (response) { setData(response.body) }
    );

  }


  return (
    <>
      <Form>
        <Row>
          <Col>
          <h6>How much do I need to earn to survive</h6>
          <p>Enter your estimated <u>Monthly Expenses</u> and assuming a 40 hour work week, find out the minimum <u>Hourly Rate</u> or <u>Salary</u>
          required to acheive an <u>Expense Ratio</u> of 70%, 80% and 90%. That will determine your <u>Spending Cash</u> for the month.</p>
          </Col>
        </Row>
        <Row>
          <ProvinceControl as={Col} label="Province" value={province} onChange={setProvince} />
        </Row>

        <BudgetBuilder budget={budget} onChange={updateBudget}/>

        <Row>
          <Col xs={4} style={expense_labels}>Other</Col>
          <Col xs={4}>
          <InputGroup size="sm">
          <InputGroup.Text>+</InputGroup.Text>
          <Form.Control type="text" size="sm" style={input_text2_style} value={otherExpenses} onChange={updateOtherExpenses} />
          </InputGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={4} style={expense_labels}>Total</Col>
          <Col xs={4}>
          <InputGroup className="mb-3" size="sm">
          <InputGroup.Text>=</InputGroup.Text>
          <Form.Control type="text" size="sm" style={input_text2_style} value={totalBudget} readOnly />
          </InputGroup>
          </Col>
        </Row>



        <Button variant="primary" onClick={handleClick}>Submit</Button>
        <Button variant="secondary" onClick={props.onCancel}>Cancel</Button>

      </Form >

      <RequiredPay results={data} />
    </>

  );
}
/*
        <Row>
          <Form.Group as={Col}>
            <Form.Label>Expenses</Form.Label>
            <Form.Control type="text" value={otherExpenses} onChange={updateOtherExpenses} />
          </Form.Group>
        </Row>
*/


function BudgetBuilder(props) {
  let budget = props.budget.map(b => b);
  const [estimatedBudget, setEstimatedBudget] = useState(calcBudget(budget));
  const [updatedBudget, setUpdatedBudget] = useState(calcBudget(budget));
  const [showBuilder, setShowBuilder] = useState(false);
  const [count, setCount] = useState({});


  useEffect(() => {

  }, [count]);


  function onShowBuilder(event) {
    event.preventDefault();

    setShowBuilder(!showBuilder);
  }


  function updateEstimate(i, val) {
    // Probably a cleaner way to do this, but maybe not
    budget[i].amount = val;
    setUpdatedBudget(calcBudget(budget));
  }


  function onUpdateBudget(event) {
    event.preventDefault();

    setEstimatedBudget(calcBudget(budget));
    props.onChange(budget);
    setShowBuilder(false);
  }


  function onCancel(event) {
    event.preventDefault();
    setShowBuilder(false);
  }



  return (
    <>
      <Row>
          <Col xs={4} style={expense_labels}>Budgeted</Col>
          <Col xs={5}>
          <InputGroup size="sm">
          <InputGroup.Text>+</InputGroup.Text>
          <Form.Control type="text" size="sm" style={input_text2_style} value={estimatedBudget} readOnly />
          </InputGroup>
          </Col>
          <Col><Button variant="success" size="sm" onClick={onShowBuilder}><i className="fas fa-edit" title="Edit"></i></Button></Col>
      </Row>


      {showBuilder &&
        <div style={list_style}>
          <Row>
            <Col xs={6}>Total</Col>
            <Col xs={3}><input type="text" style={input_text_style} value={updatedBudget} readOnly /></Col>
            <Col>
              <Button variant="success" size="sm" onClick={onUpdateBudget}><i className="fas fa-check" title="Save"></i></Button>
              <Button variant="danger" size="sm" onClick={onCancel}><i className="fas fa-close" title="Cancel" ></i></Button>
            </Col>
          </Row>

          {budget.map((b, i) => <BudgetItem key={i} index={i} item={b} onChange={updateEstimate} />)}
        </div>
      }
    </>
  );

}


function BudgetItem(props) {
  const [amount, setAmount] = useState(props.item.amount);


  function amountChanged(event) {
    event.preventDefault();

    setAmount(event.target.value);
    props.onChange(props.index, event.target.value);
  }

  const col_style = {
    boxSizing: "border-box"
  }


  return (
    <Row>
      <Col xs={6}>{props.item.desc}</Col>
      <Col xs={3} style={col_style}><input type="text" style={input_text_style} value={amount} onChange={amountChanged} /></Col>
    </Row>
  );
}


function RequiredPay(props) {

  if (props.results === null) {
    return null;
  }

  let r = props.results;


  const pay_header_style = {
    textAlign: "center",
    padding: "2px"
  }


  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th></th>
          <td style={{background: "#90EE90"}}>70% = /88K</td>
          <td style={{background: "#FED8B1"}}>80%</td>
          <td style={{background: "#FFD6D7"}}>90%</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Rate required</td>
          <td>{r.seventy.payRate.toFixed(2)}/88K</td>
          <td>{r.eighty.payRate.toFixed(2)}/88K</td>
          <td>{r.ninety.payRate.toFixed(2)}/88K</td>
        </tr>
        <tr>
          <td>Yearly</td>
          <td>{r.seventy.yearGross.toFixed(2)}</td>
          <td>{r.eighty.yearGross.toFixed(2)}</td>
          <td>{r.ninety.yearGross.toFixed(2)}</td>
        </tr>

        <tr>
          <td colSpan={4} style={pay_header_style}>Pay Period</td>
        </tr>

        <tr>
          <td>Gross</td>
          <td>{r.seventy.payGross.toFixed(2)}</td>
          <td>{r.eighty.payGross.toFixed(2)}</td>
          <td>{r.ninety.payGross.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Net</td>
          <td>{r.seventy.payNet.toFixed(2)}</td>
          <td>{r.eighty.payNet.toFixed(2)}</td>
          <td>{r.ninety.payNet.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Month Net</td>
          <td>{r.seventy.monthNet.toFixed(2)}</td>
          <td>{r.eighty.monthNet.toFixed(2)}</td>
          <td>{r.ninety.monthNet.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Expenses</td>
          <td>{r.seventy.expenses.toFixed(2)}</td>
          <td>{r.eighty.expenses.toFixed(2)}</td>
          <td>{r.ninety.expenses.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Available cash</td>
          <td>{r.seventy.monthDiff.toFixed(2)}</td>
          <td>{r.eighty.monthDiff.toFixed(2)}</td>
          <td>{r.ninety.monthDiff.toFixed(2)}</td>
        </tr>
      </tbody>
    </Table>
  );
}


export default CanadaPayRequired;

